export default "__VITE_ASSET__C184KcLt__"